import { RJSFSchema } from '@rjsf/utils';

export class ModuleSettingsFormSchema {
  static Build(): RJSFSchema {
    return {
      type: 'object',
      properties: {
        name: {
          type: 'string',
          title: 'Name'
        },
        status: {
          type: 'string',
          title: 'Status',
          readOnly: true,
          oneOf: [
            { type: 'string', title: 'Active', enum: ['active'] },
            { type: 'string', title: 'Deleted', enum: ['deleted'] }
          ]
        },
        position: {
          type: 'object',
          title: 'Position',
          properties: {
            x: { type: 'number', title: 'x (cm)', readOnly: true },
            y: { type: 'number', title: 'y (cm)', readOnly: true },
            a: { type: 'number', title: 'a (degrees)', readOnly: true }
          }
        },
        dimensions: {
          type: 'object',
          title: 'Dimensions',
          properties: {
            widthCm: { type: 'number', title: 'Width (cm)', readOnly: true },
            heightCm: { type: 'number', title: 'Height (cm)', readOnly: true },
            depthCm: { type: 'number', title: 'Depth (cm)', readOnly: true }
          }
        }
      },
      required: ['name']
    };
  }
}
